import { BusinessObjectBase } from './base';
import type { Candidate } from './candidate';

export interface ContactDetailsData {
  readonly id: number;
  readonly phoneType?: string;
  readonly phoneNumber?: string;
  readonly otherPhoneType?: string;
  readonly otherPhoneNumber?: string;
  readonly email?: string;
  readonly candidateId: number;
  readonly candidate?: Candidate;
}

export interface ContactDetails extends Readonly<ContactDetailsData> {}
export class ContactDetails extends BusinessObjectBase {
  static readonly entityName = 'ContactDetails' as const;
  static readonly plural = 'contact-details';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<ContactDetails[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new ContactDetails(data));
  }

  static async findOne(filter?: any): Promise<ContactDetails | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new ContactDetails(data) : null;
  }

  static async findById(id: number, filter?: any): Promise<ContactDetails> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new ContactDetails(data);
  }

  static async create(
    data: Omit<ContactDetailsData, 'id'>,
  ): Promise<ContactDetails> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new ContactDetails(result);
  }

  static async updateById(
    id: number,
    data: Partial<ContactDetailsData>,
  ): Promise<ContactDetails> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new ContactDetails(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
